
import { defineComponent } from 'vue'

// type FormErrors = Record<string, string[]>;

export default defineComponent({
    name: 'FieldError',
    props: {
        errors: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {};
    },
});
